class PrivacyController {
  /* @ngInject */
  constructor(TermsService, docService, endPoints, StorageService) {
    const that = this;

    that.terms = [];
    that.dirty = false;
    that.loaderButton = false;
    
    var acceptedTermIds = [];
    var rejectedTermIds = [];


    that.getTerms = () => {
      TermsService.getTerms(true).then((result) => {
        that.terms = result;
        that.dirty = false;
      });
    };

    that.resetTerms = () => {
      that.getTerms(true);
    };

    that.setDirty = (condition) => {
      if (!condition) {
        that.dirty = true;
      }
    };

    that.setTerms = (term) => {
      if(!term.accepted){
        acceptedTermIds.push(term.termId);
      }else if(!term.mandatory){
        rejectedTermIds.push(term.termId);
      }else{
        term.accepted = true;
      }
    }


    that.sendTerms = () => {
      that.loaderButton = true;
        TermsService.modifyTerms(acceptedTermIds, rejectedTermIds).then(() => {
          acceptedTermIds = [];
          rejectedTermIds = [];
          that.loaderButton = false;
        });     
    };

    that.showDoc = () => {
      const url =`${endPoints.baseUrl}/api/usr/v2/documents/terms/9`;
      docService.showDoc(url, true);
    };

    that.getTerms(true);
  }
}

export default PrivacyController;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/account/privacy/privacy.controller.js
 **/